import React from "react";
import { Route, Redirect } from "react-router-dom";


const CheckRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest} // Le pongo el "resto" de las propiedades que llegan al componente
    render={props => {
        if(Object.keys(rest.result).length){
          return <Component {...props} result={rest.result} />;
        }else{ 
          return <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        }
    }}
  />
);

export default CheckRoute;
